import React from 'react';
import { t } from '../../utils/helpers';
import { ForgotPassword } from '../../features/auth/components/fogotPassword/forgotPassword';
import AuthWrapImage from '@base/features/auth/components/authWrapImage';
const ForgotPasswordPage = () => {
  return (
    <div className="auth">
      <AuthWrapImage />
      <div className="register-page">
        <h1 className="forgot-password__title">{t('recovery_password')}</h1>
        <div className="register-content-wrap">
          <div className="forgot-password">
            <div className="forgot-password__description">
              <p>{t('if_forgot_gc_password_enter_username')}</p>
            </div>
            <ForgotPassword />
          </div>
        </div>
      </div>
      <div id="recaptcha-container" />
    </div>
  );
};

export default ForgotPasswordPage;
